// extracted by mini-css-extract-plugin
export default {"content":"styles_content__K56Z2","choiceSeatsBox":"styles_choiceSeatsBox__O9HUh"};